export const CATG_MASTER_ACTION = 'CATG_MASTER_ACTION';
export const CATG_MASTER_SUCCESS_ACTION = 'CATG_MASTER_SUCCESS_ACTION';
export const CATG_MASTER_FAILURE_ACTION = 'CATG_MASTER_FAILURE_ACTION';
